<template>
  <section>
    <Title :title-name="title.Error.titleName" :title-link="title.Error.titleLink" :name-page="namePage" />
    <div class="container" style="margin-top: 14pt">
      <p v-if="pax && pax.full_name">Dear {{ pax.title ? pax.title + ':' : '' }} {{ pax.full_name }},</p>
      <p v-else>Dear Guest,</p>
      <p>
        Unfortunately something went wrong, with the link you have received.<br />
        Please go to your nearest {{ airline.name }} service desk and check with our staff.<br />
        Apologies for the inconvenience.
      </p>
    </div>
  </section>
</template>

<script>
import Title from '@/components/Title/index'
export default {
  name: 'Error',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      namePage: 'Error'
    }
  },
  created: function () {
    this.$emit('changeLinkName', '')
  }
}
</script>
